import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AdminLogin from "./components/AdminLogin";
import { AdminRoutes } from "./routes/admin.routes";
import LoginPage from "./pages/LoginPage";
import ResetPage from "./pages/ResetPage";
import HomePage from "./pages/HomePage";
import Premium from "./pages/Premium";
import Checkout from "./pages/Checkout";
import { LearnRoutes } from "./routes/learn.routes";
import { PageRoutes } from "./routes/page.routes";
import { AffiliateRoutes } from "./routes/affiliate.routes";
import { AccountRoutes } from "./routes/account.routes";
import AccountShield from "./components/AccountShield";
import AdminShield from "./components/AdminShield";
import { UserProvider } from "./contexts/UserContext";
import { SiteProvider } from "./contexts/SiteContext";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

import Register from "./pages/RegisterPage";
import UserLogout from "./components/UserLogout";
import MainLayout from "./layouts/MainLayout";
import "./custom.scss";
import "@fontsource/roboto-slab/300.css";
import "@fontsource/noto-serif-malayalam/400.css";
import "@fontsource/noto-serif-malayalam/600.css";

function App() {
  return (
    <Router>
      <SiteProvider>
        <UserProvider>
          <Routes>
            <Route element={<MainLayout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/xl-login" element={<AdminLogin />} />
              <Route path="/signup" element={<Register />} />
              <Route path="/reset" element={<ResetPage />} />
              <Route path="/logout" element={<UserLogout />} />
              <Route path="/premium" element={<Premium />} />
              <Route
                path="/premium/checkout"
                element={
                  <AccountShield>
                    <Checkout />
                  </AccountShield>
                }
              />
            </Route>

            <Route path="/learn/*" element={<LearnRoutes />} />
            <Route path="/page/*" element={<PageRoutes />} />
            <Route path="/affiliate/*" element={<AffiliateRoutes />} />
            <Route path="/account/*" element={<AccountRoutes />} />
            <Route
              path="/xl-admin/*"
              element={
                <AdminShield allowedRoles={["admin", "editor", "superadmin"]}>
                  <AdminRoutes />
                </AdminShield>
              }
            />
          </Routes>
        </UserProvider>
      </SiteProvider>
    </Router>
  );
}

export default App;
